import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SwitchAccountIcon(props: IconProps) {
    return <Icon {...props} iconKey={"switch_account"}/>
}
